/**
 * Layout constants for 3D scene generation.
 *
 * IMPORTANT — PDF officiel GoRampe "Configurations de rampes" :
 *   Plateforme tête   : 60×60 (5×5) standard, 60×96 (5×8) pour rampes hautes
 *   Palier virage L90 : 60×60 (5×5) standard, 60×96 (5×8) pour switchback
 *   Largeur rampe     : 36" STANDARD ou 42"/44" OPTION (PAS 48")
 *
 * Legacy 48×48 platforms (F01005) were used pre-2026-05 before the official
 * GoRampe PDF was checked into the project. All new configurations default
 * to 60×60. The 48 values are kept only as deprecated aliases so legacy
 * imports don't break — they are no longer used by the layouts themselves
 * (which read from config.headPlatformDepthIn / shape.landingDepthIn).
 */

/** Default head platform depth (in) — matches PDF officiel 60×60 (5×5) standard. */
export const DEFAULT_HEAD_PLATFORM_DEPTH_IN = 60;
/** Default head platform width (in) — matches PDF officiel 60×60 (5×5) standard. */
export const DEFAULT_HEAD_PLATFORM_WIDTH_IN = 60;
/** Default turn-landing size (in) — matches PDF officiel 60×60 (5×5) standard. */
export const DEFAULT_TURN_LANDING_SIZE_IN = 60;

/** @deprecated Use config.headPlatformDepthIn ?? DEFAULT_HEAD_PLATFORM_DEPTH_IN */
export const HEAD_PLATFORM_DEPTH_IN = DEFAULT_HEAD_PLATFORM_DEPTH_IN;
/** @deprecated Use DEFAULT_HEAD_PLATFORM_WIDTH_IN */
export const HEAD_PLATFORM_WIDTH_IN = DEFAULT_HEAD_PLATFORM_WIDTH_IN;
/** @deprecated Use shape.landingDepthIn ?? DEFAULT_TURN_LANDING_SIZE_IN */
export const TURN_LANDING_SIZE_IN = DEFAULT_TURN_LANDING_SIZE_IN;

export const LANDING_SIZE_IN = 60;
export const SAFETY_GAP_IN = 0;
export const EDGE_OVERLAP_IN = 1;
export const RAIL_CLEARANCE_IN = 4;
